import { render, staticRenderFns } from "./review-redirect.vue?vue&type=template&id=85de2f8c"
import script from "./review-redirect.vue?vue&type=script&lang=js"
export * from "./review-redirect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports